import { BarChart3, Brain, Crown, Gem, Lock, LockOpen, Smartphone } from "lucide-react";

const PRODUCTS = [
  { id: "nfts", label: "NFTs", icon: Gem },
  { id: "portfolios", label: "SMART PORTFOLIOS", icon: BarChart3 },
  { id: "app", label: "KINGBULLISH APP", icon: Smartphone },
  { id: "ai", label: "KB AI", icon: Brain },
];

export const EnergyIdentity = ({ targetLabel, isUnlocked }) => {
  const StatusIcon = isUnlocked ? LockOpen : Lock;
  return (
    <div className="energy-identity" data-testid="energy-core-identity">
      <div className="energy-identity__head">
        <span className="energy-insignia" aria-hidden="true" data-testid="energy-core-lock-icon">
          <StatusIcon /><Crown className="energy-insignia__crown" />
        </span>
        <div className="energy-identity__text">
          <h2 id="energy-core-heading" data-testid="energy-core-heading">NEXT MAJOR ECOSYSTEM UNLOCK</h2>
          <div className="energy-identity__amount" data-testid="energy-core-target-amount">{targetLabel}</div>
        </div>
      </div>
      <ul className="energy-products" data-testid="energy-core-product-labels">
        {PRODUCTS.map(({ id, label, icon: Icon }) => (
          <li key={id} data-testid={`energy-core-product-${id}`} data-state={isUnlocked ? "unlocked" : "locked"}>
            <Icon className="energy-products__icon" aria-hidden="true" />
            <span className="energy-products__name" data-testid={`energy-core-product-${id}-name`}>{label}</span>
            <span className="energy-products__state" data-testid={`energy-core-product-${id}-state`}>
              <StatusIcon aria-hidden="true" /> {isUnlocked ? "UNLOCKED" : "LOCKED"}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};